import { render, staticRenderFns } from "./footerComponent.vue?vue&type=template&id=9e11e97a&scoped=true"
import script from "./footerComponent.vue?vue&type=script&lang=js"
export * from "./footerComponent.vue?vue&type=script&lang=js"
import style0 from "./footerComponent.vue?vue&type=style&index=0&id=9e11e97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e11e97a",
  null
  
)

export default component.exports